import { TwMainColor } from "data/types";
import React, { FC, ReactNode } from "react";
import { Link } from "react-router-dom";

export interface BadgeProps {
	className?: string;
	type: ReactNode;
	color?: TwMainColor;
	href?: string;
}

const CommunityBadge: FC<any> = ({
	className = "relative",
	type,
	color = "blue",
	href,
}) => {

	let _color = "blue";
	let _text = "";

	switch (type) {
		case "all":
			_color = "yellow";
			_text = `ALL`; 
			break;
		case "event":
			_color = "purple";
			_text = `이벤트 공지`; 
			break;
		case "review":
			_color = "blue";
			_text = `투어후기`; 
			break;
		case "party":
			_color = "green";
			_text = `투어동행찾기`; 
			break;
		case "request":
			_color = "pink";
			_text = `단체투어문의`; 
			break;
		// case "hotspot":
		// 	_color = "purple";
		// 	_text = `코스소개`; 
		// 	break;
		case "qna":
			_color = "gray";
			_text = `Q & A`; 
			break;
	}


	const getType = (_type: string) => {
		
		switch (_type) {
			case "review":
				return `리뷰`;
			case "party":
				return `파티원 모집`;
			case "request":
				return `상품요청`;
			case "hotspot":
				return `코스소개`;
			case "qna":
				return `질문`;
		}
	};
	
	const getColorClass = (hasHover = true) => {
		switch (_color) {
			case "pink":
				return `text-pink-800 bg-pink-100 ${
				hasHover ? "hover:bg-pink-800" : ""
				}`;
			case "red":
				return `text-red-800 bg-red-100 ${hasHover ? "hover:bg-red-800" : ""}`;
			case "gray":
				return `text-gray-800 bg-gray-100 ${
				hasHover ? "hover:bg-gray-800" : ""
				}`;
			case "green":
				return `text-green-800 bg-green-100 ${
				hasHover ? "hover:bg-green-800" : ""
				}`;
			case "purple":
				return `text-purple-800 bg-purple-100 ${
				hasHover ? "hover:bg-purple-800" : ""
				}`;
			case "indigo":
				return `text-indigo-800 bg-indigo-100 ${
				hasHover ? "hover:bg-indigo-800" : ""
				}`;
			case "yellow":
				return `text-yellow-800 bg-yellow-100 ${
				hasHover ? "hover:bg-yellow-800" : ""
				}`;
			case "blue":
				return `text-blue-800 bg-blue-100 ${
				hasHover ? "hover:bg-blue-800" : ""
				}`;
			default:
				return `text-pink-800 bg-pink-100 ${
				hasHover ? "hover:bg-pink-800" : ""
				}`;
		}
	};

	const CLASSES =
		"nc-Badge inline-flex px-2.5 py-1 rounded-full font-medium text-sm " +
		className;
		
	return !!href ? (
		<Link
			to={href || ""}
			className={`transition-colors hover:text-white duration-300 ${CLASSES} ${getColorClass()}`}
		>
			{_text}
		</Link>
	) : (
		<span className={`${CLASSES} ${getColorClass(false)} ${className}`}>
			{_text}
		</span>
	);
};

export default CommunityBadge;
